import { gql, useQuery } from "@apollo/client";

export type Chart = {
  id: string;
  title: string;
  updatedAt: string;
  createdAt: string;
  screenshotUrl?: string;
};

export type ChartsResponse = {
  charts: {
    charts: Chart[];
    totalCount: number;
  };
};

const ChartsQuery = gql`
  query charts {
    charts {
     charts {
        id
        title
        updatedAt
        createdAt
        screenshotUrl
      }
      totalCount
    }
  }
`;

export const useChartQuery = () =>
  useQuery<ChartsResponse>(ChartsQuery, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "cache-first",
  });
